import { getEffectiveUser, useEffectiveUser } from '@fs/zion-user'

type EffectiveUserId = {
  cisId?: string
  cpUserId?: string
  effectiveUserId: string
}

/**
 * These helper functions return cpUserId for helper mode and non helper mode.
 * In helper mode cisId will be cisId.user.{cpUserId} and cpUserId will be undefined
 * In normal user mode cisId will be undefined and cpUserId will be valid
 */
export async function getEffectiveUserId(): Promise<EffectiveUserId> {
  const { cisId, cpUserId, ...rest } = await getEffectiveUser()
  const effectiveUserId = cpUserId ?? cisId
  return { cisId, cpUserId, effectiveUserId, ...rest }
}

export default function useEffectiveUserId(): Partial<EffectiveUserId> {
  const { cisId, cpUserId, ...rest } = useEffectiveUser()
  const effectiveUserId = cpUserId ?? cisId
  return { cisId, cpUserId, effectiveUserId, ...rest }
}
